import React from "react";
import { Table } from "react-bootstrap";
import PersonView from "./PersonView";
import DateRenderer from "./renderers/DateRenderer";
import TimeRenderer from "./renderers/TimeRenderer";

interface AccessLogTableViewProps
{
    data: AccessLogRecord[];
    offset: number;
}

export default class AccessLogTableView extends React.Component<AccessLogTableViewProps>
{
    constructor(props: any) 
    {
        super(props);

        this.state = {
            data: this.props.data
        };
    }


    formatText(camelCase: string): string 
    {
        const splitStr = camelCase.split(/(?=[A-Z])/).join(" ");
        const finalStr = splitStr.charAt(0).toUpperCase() + splitStr.slice(1);

        return finalStr;
    }

    render(): React.ReactNode 
    {
        return <Table responsive className="list">
            <thead>
                <tr>
                    <th>DATE</th>
                    <th>TIME</th>
                    <th>NAME</th>
                    <th>ROLE</th>
                </tr>
            </thead>
            <tbody>
                {
                    (this.props.data && this.props.data.length > 0)
                        ?
                        this.props.data.map((accessLog: AccessLogRecord, i: number) => 
                        {
                            return <tr key={i}>
                                <td className="td-normal"><DateRenderer timezone={true} value={accessLog.timestamp} type={"long"} /></td>
                                <td className="td-normal"><TimeRenderer value={accessLog.timestamp} /></td>
                                <td><PersonView data={accessLog.user} /></td>
                                <td className="td-normal">{this.formatText(accessLog.user.role)}</td>
                            </tr>;
                        })
                        :
                        <tr className={"text-center"}>
                            <td colSpan={4}>
                                <p className="error-text">No Access Logs data available</p>
                            </td>
                        </tr>
                }
            </tbody>
        </Table>;
    }
}